<template>
  <div class="input-field">
    <label
      v-if="!hideLabel && label"
      :class="{ 'required-flag': required && !readonly ? showFlag : false }"
    >{{ label }}{{ showColon ? ':' : '' }}</label>
    <span v-if="!readonlyAsInput && readonly">{{ showReadOnlyText }}</span>
    <div
      v-if="readonlyAsInput || !readonly"
      class="row text-input"
    >
      <p
        v-if="hintBeforeInput"
        :class="hintClass"
      >{{ hintBeforeInput }}</p>
      <input
        :class="[{ 'small-2 medium-2 large-2 columns': text }, extendClass]"
        v-autosize
        v-hkldinput="{ component: parentNode, unchecked: !dirtyCheck }"
        :value="value"
        :disabled="readonlyAsInput"
        :placeholder="placeholder"
        @blur="onChange"
        @input="onInput"
        @change="onChange"
        v-fusioninputcheck="fusionInputCheckBinding"
        :required="required"
      >
      <pre
        :class="{'additional-text': text}"
        v-if="text"
      ><p>{{ text }}</p></pre>
    </div>
  </div>
</template>

<script>
import i18n from '@/utils/i18n'
export default {
  name: 'input-field',
  model: {
    prop: 'value',
    event: 'updateValue',
  },
  props: {
    label: String,
    value: {
      type: [String, Number],
      default: null,
    },
    extendClass: {
      type: String,
      default: '',
    },
    noSpace: {
      type: Boolean,
      default: false,
    },
    autoTrim: {
      type: Boolean,
      default: true,
    },
    text: String,
    hideLabel: Boolean,
    required: Boolean,
    readonly: Boolean,
    readonlyAsInput: {
      type: Boolean,
      default: false,
    },
    showColon: {
      type: Boolean,
      default: true,
    },
    showFlag: {
      type: Boolean,
      default: true,
    },
    showEmptyDash: {
      type: Boolean,
      default: false,
    },
    hintBeforeInput: String,
    hintClass: String,
    placeholder: String,
    parentNode: String,
    dirtyCheck: {
      type: Boolean,
      default: true,
    },
    inputTip: {
      type: String,
      default: () => i18n.t('hint.inputTip.string'),
    },
    inputCheckType: {
      type: String,
      default: 'string',
    },
    pattern: {
      type: RegExp,
    },
    patternOnly: {
      type: Function,
      default: null,
    },
  },
  computed: {
    showReadOnlyText () {
      return this.value ? this.value : (this.showEmptyDash ? this.$t('emptyValue') : '')
    },
    fusionInputCheckBinding () {
      const binding = {
        type: this.inputCheckType,
        pattern: this.pattern,
        tip: this.inputTip,
        required: this.required,
      }
      if (this.patternOnly) {
        binding.patternOnly = this.patternOnly
      }
      return binding
    },
  },
  methods: {
    onChange (e) {
      let val = e.target.value
      if (this.autoTrim && typeof val === 'string') {
        val = val.trim()
        e.target.value = val
      }
      // If the input is disabled, don't emit the event.
      // Then the user can't not change value by inspect tools
      if (!this.readonlyAsInput) {
        this.$emit('updateValue', val)
      }
    },
    onInput (e) {
      let val = e.target.value
      if (this.noSpace) {
        e.target.value = (val || '').replace(/\s/g, '')
      }
      if (!this.readonlyAsInput) {
        this.$emit('input', val)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import '~styles/common';
@import '~styles/textField';

input {
  padding-left: 10px;
}
</style>
